export enum BankAccountsStatus {
  FirstAttemptManual = 'Manual',
  SecondAttemptManual = 'Second Attempt Manual',
  ThirdAttemptManual = 'Third Attempt Manual',
  PendingPayrollProvider = 'Pending',
  ReceivedPayrollProvider = 'Received',
  FinancialAccounts = 'Financial Accounts',
  PendingFinancialAccounts = 'Pending Financial Accounts',
  ReceivedFinancialAccounts = 'Received From Financial Accounts',
  Done = 'Done',
  FinancialAccountsAggregationError = 'Financial Accounts Aggregation Error',
}
